import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { LANDING } from "@/constants/testIds";

const faqs = [
    {
        q: "How does Apex Pro handle offline operations at sea or in remote sites?",
        a: "Field users can log cases, upload evidence, and update actions entirely offline through the mobile client. All records are cached locally with checksum validation, and sync automatically the moment connectivity is restored — with conflict resolution built in.",
    },
    {
        q: "What case categories are supported out of the box?",
        a: "Three top-level categories: Safety Case Management, Assurance Case Management, and Audit Case Management. Each supports configurable sub-categories tailored to your organisation, regulator, and operating regime.",
    },
    {
        q: "Can Apex Pro benchmark across multiple worksites and departments?",
        a: "Yes. The benchmarking module aggregates safety data across sites, departments, and the enterprise — allowing you to compare KPIs, spot trends early, and drive continuous improvement with data-backed decisions.",
    },
    {
        q: "How is the Action Tracker different from a typical task list?",
        a: "Actions are natively linked to their originating case, retain the full evidence chain, enforce ownership and due dates, and surface close-out documentation. Overdue actions escalate automatically via configurable workflows.",
    },
    {
        q: "How customisable is the platform?",
        a: "Selected features — fields, sub-categories, workflows, dashboards and reports — are customisable to meet company and client requirements. Our onboarding team configures the platform to match how your organisation actually operates.",
    },
    {
        q: "How long does implementation take?",
        a: "A typical deployment can go live in days, not weeks. Onboarding, training and operational solutions are available if required.",
    },
];

export const FAQ = () => {
    return (
        <section id="faq" className="relative bg-white py-24 md:py-32">
            <div className="max-w-6xl mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
                    <div className="md:col-span-4">
                        <span className="label-eyebrow text-[#0052CC]">// FAQ</span>
                        <h2 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold text-[#091524] tracking-tight leading-[1.05]">
                            Answers, before you ask.
                        </h2>
                        <p className="mt-6 text-[#475569]">
                            Still curious? Reach out &mdash; we&apos;ll get you a straight
                            answer from a real person, not a chatbot.
                        </p>
                    </div>

                    <div className="md:col-span-8">
                        <Accordion type="single" collapsible className="w-full">
                            {faqs.map((f, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    className="border-b border-[#091524]/10"
                                >
                                    <AccordionTrigger
                                        data-testid={LANDING.faqItem(i)}
                                        className="text-left font-display font-bold text-lg md:text-xl text-[#091524] hover:text-[#0052CC] hover:no-underline py-6"
                                    >
                                        {f.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-[#475569] text-base leading-relaxed pb-6 pr-6">
                                        {f.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
};
